import { render, staticRenderFns } from "./ShopifyEntry.vue?vue&type=template&id=42e2d45e&scoped=true&"
import script from "./ShopifyEntry.vue?vue&type=script&lang=js&"
export * from "./ShopifyEntry.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyEntry.vue?vue&type=style&index=0&id=42e2d45e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2d45e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
